import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class TimeTracking extends Field {
  static subqueriesForModel() {
    return { bestEstimate: ['text'] };
  }

  get title() {
    return 'Best estimate';
  }

  exampleContents(): FieldContentsData {
    return { text: '2d', icon: { name: 'fa-regular fa-clock' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.bestEstimate?.text) {
      return {
        text: record.bestEstimate.text,
        icon: { name: 'fa-regular fa-clock' },
      };
    }

    return {};
  }
}
